import i18n from '../../i18n'
export default {
  namespaced: true,
  state: () => ({
    all: [
      { nombre: i18n.t('schedule.days.mon') },
      { nombre: i18n.t('schedule.days.tue') },
      { nombre: i18n.t('schedule.days.wed') },
      { nombre: i18n.t('schedule.days.thu') },
      { nombre: i18n.t('schedule.days.fri') },
      { nombre: i18n.t('schedule.days.sat') },
      { nombre: i18n.t('schedule.days.sun') }
    ]
  }),
  getters: {
    all: (state) => state.all
  }
}
